import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import VuexPersistence from 'vuex-persist';
import { LocalStorage } from '@/globals/LocalStorageGlobal';
import { form } from './modules/form';
import { message } from './modules/message';
import { authorization } from '@/store/modules/authorization';
import { authentication } from '@/store/modules/authentication';
import { AxiosError } from 'axios';
import { lobby } from '@/store/modules/lobby';
import { document } from '@/store/modules/document';
import { manager } from '@/store/modules/manager';
import { customer } from '@/store/modules/backoffice/customer';
import { system } from '@/store/modules/system';
import { messages } from '@/store/modules/backoffice/messages';
import { applicationUser } from '@/store/modules/application-user';
import { insurersReports } from '@/store/modules/insurers-reports';
import { adpFiles } from '@/store/modules/adp-file-control';

Vue.use(Vuex);

export interface RootState {
  idleVue: any;
  globalError: AxiosError | null;
}

export const rootState: RootState = {
  idleVue: {} as any,
  globalError: null,
};

const vuexLocal = new VuexPersistence<RootState>({
  key: LocalStorage.VUEX_PERSIST,
  storage: window.localStorage,
  supportCircular: true,
  reducer: (state: any) => ({
    authentication: state.authentication,
    authorization: state.authorization,
    form: state.form,
    customer: {
      allCustomersErrors: state.customer.allCustomersErrors,
      customerDetails: state.customer.customerDetails,
      updateCustomerSettingsModal: state.customer.updateCustomerSettingsModal,
      updateCustomerSettingsModalErrors: state.customer.updateCustomerSettingsModalErrors,
      allOfficesByCustomer: state.customer.allOfficesByCustomer,
      allOfficesErrors: state.customer.allOfficesErrors,
      officeDetails: state.customer.officeDetails,
      updateOfficeSettingsModal: state.customer.updateOfficeSettingsModal,
      updateOfficeSettingsModalErrors: state.customer.updateOfficeSettingsModalErrors,
      allRemindersByCustomer: state.customer.allRemindersByCustomer,
      openCreateRemindersModal: state.customer.openCreateRemindersModal,
      openCreateRemindersModalErrors: state.customer.openCreateRemindersModalErrors,
      managersByCustomer: state.customer.managersByCustomer,
      managerToAdd: state.customer.managerToAdd,
      managerToDelete: state.customer.managerToDelete,
      openDeleteManagerModal: state.customer.openDeleteManagerModal,
      openDeleteManagerModalErrors: state.customer.openDeleteManagerModalErrors,
      managerToUpdate: state.customer.managerToUpdate,
      openUpdateManagerModal: state.customer.openUpdateManagerModal,
      openUpdateManagerModalErrors: state.customer.openUpdateManagerModalErrors,
      openAddManagerModal: state.customer.openAddManagerModal,
      openAddManagerModalErrors: state.customer.openAddManagerModalErrors,
      managerPrivileges: state.customer.managerPrivileges,

    },
    idleVue: state.idleVue,
    manager: state.manager,
  }),
});

const store: StoreOptions<RootState> = {
  state: rootState,
  actions,
  getters,
  mutations,
  modules: {
    authentication,
    authorization,
    form,
    lobby,
    document,
    manager,
    customer,
    message,
    system,
    messages,
    applicationUser,
    insurersReports,
    adpFiles,
  },
  plugins: [vuexLocal.plugin],
};

export default new Vuex.Store<RootState>(store);
